import {StorageProvider} from "./storage";

export const ConstCompany : any = {
//
// module.exports = {

    license: {

        FREE: 0,                // original old free 25
        FREE_25: 4,             // temp free 25 May 19
        FREE_15: 3,             // trial has expired - free now - 15 users

        PROFESSIONAL_OLD: 1,    // manual subscription or no subsription
        PROFESSIONAL: 2,       // automatic subscriptions

        TRIAL_PRO: 10,         // manual trial - old may 2019
        TRIAL_PRO_14: 11,       // Pro trial for 14 days
        TRIAL_PRO_21: 12,       // Pro trial for 21 days
        TRIAL_PRO_30: 13,       // Pro trial for 30 days

        PRO_PAY_PER_USER: 20,    // automatic payment pay per user
        PRO_FLAT_RATE_10_USERS: 30,   // automatic payment flat rate 10 users (29.95)
        PRO_FLAT_RATE_15_USERS: 31,    // automatic payment flat rate 15 users (39.95)

        PRO_2023        : 40,    //
        BUSINESS_2023   : 50,    //

        ENTERPRISE      : 100        // just to reserve

    },

    finance: {
        DISABLED: 0,
        INTERNAL: 1,
        EXTERNAL: 2,
        INTERNAL_EXTERNAL: 3
    },

    role: {
        CLIENT: 1,
        GUEST: 2,
        USER: 3,
        MANAGER: 4,
        ADMIN: 5
    },

    roleDictionary: {
        1: 'Client',
        2: 'Guest',
        3: 'User',
        4: 'Manager',
        5: 'Admin'
    },

    defaultAccess: {
        NONE        : 1,
        ADMIN       : 2,
        MANAGER     : 3,

        dictionary  : {
            1           : 'None',
            2           : 'Administrators',
            3           : 'Administrators & Managers',

        }
    },

    companySize: [
        {label: "1-5",              value: 1},
        {label: "6-15",             value: 2},
        {label: "16-25",            value: 3},
        {label: "26-50",            value: 4},
        {label: "51-100",           value: 5},
        {label: "101-250",          value: 6},
        {label: "250-500",          value: 7},
        {label: "500-1000",         value: 8},
        {label: "1000+",            value: 9}
    ],

    companyIndustry: [
        {label: "Information Technology",       value: 1},
        {label: "Marketing / Creative agency",  value: 2},
        {label: "Services / Consulting",        value: 3},
        {label: "Education",                    value: 4},
        {label: "Non-profit",                   value: 5},
        {label: "Government",                   value: 6},
        {label: "Finance",                      value: 7},
        {label: "Legal",                        value: 8},
        {label: "Manufacturing",                value: 9},
        {label: "Other",                        value: 99},
    ],

    dataStorage: [
        {label: "North America",    value: StorageProvider.AMAZON_NORTH_AMERICA},
        {label: "Europe",           value: StorageProvider.AMAZON_EUROPE},
        {label: "South America",    value: StorageProvider.AMAZON_SOUTH_AMERICA},
        {label: "Asia / Pacific",   value: StorageProvider.AMAZON_ASIA},
    ]
};
